import { useState, type ReactNode } from "react";
import { useT } from "../i18n";

export interface WizardStep {
  label: string;
  helper?: string;
  icon?: ReactNode;
  render: () => ReactNode;
  canAdvance: () => boolean;
}

export function Wizard({
  steps,
  onFinish,
}: {
  steps: WizardStep[];
  onFinish: () => void;
  titleBadge?: ReactNode;
}) {
  const { t } = useT();
  const [index, setIndex] = useState(0);
  const step = steps[index];
  const isLast = index === steps.length - 1;
  const progressPercent = ((index + 1) / steps.length) * 100;

  return (
    <div className="flow-wizard">
      {/* Sleek Minimalist Progress Bar */}
      <div className="flow-progress-track">
        <div
          className="flow-progress-fill"
          style={{ width: `${progressPercent}%` }}
        />
      </div>

      <div className="flow-step-header">
        <div className="flow-step-counter">
          <span className="flow-step-current">
            {String(index + 1).padStart(2, "0")}
          </span>
          <span className="flow-step-divider">/</span>
          <span className="flow-step-total">
            {String(steps.length).padStart(2, "0")}
          </span>
        </div>
      </div>

      <div className="flow-body">
        <h2 className="flow-title">{step.label}</h2>
        {step.helper && <p className="flow-helper">{step.helper}</p>}

        <div className="flow-input-container">{step.render()}</div>
      </div>

      <div className="flow-actions">
        {index > 0 && (
          <button
            className="flow-btn-back"
            type="button"
            onClick={() => setIndex(index - 1)}
          >
            ← Back
          </button>
        )}
        <button
          className="flow-btn-next"
          type="button"
          disabled={!step.canAdvance()}
          onClick={() => (isLast ? onFinish() : setIndex(index + 1))}
        >
          <span>{isLast ? "Schedule Session →" : "Continue →"}</span>
        </button>
      </div>
    </div>
  );
}
